import { render } from "./ChangePass.vue?vue&type=template&id=12062e72&scoped=true"
import script from "./ChangePass.vue?vue&type=script&lang=js"
export * from "./ChangePass.vue?vue&type=script&lang=js"

import "./ChangePass.vue?vue&type=style&index=0&id=12062e72&lang=scss&scoped=true"

import exportComponent from "G:\\Programming\\VueProjects\\radinrealp2p\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12062e72"]])

export default __exports__